import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Box, CircularProgress, Typography, Button } from '@mui/material';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase/config';

const DashboardRedirect = () => {
  const { currentUser, userProfile } = useAuth();


  if (!currentUser) {
    return <Navigate to="/auth" replace />;
  }

  if (!currentUser.emailVerified) {
    return <Navigate to="/auth" replace />;
  }

  if (!userProfile) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: '#fafaf9',
          gap: 2
        }}
      >
        <Box
          sx={{
            width: 48,
            height: 48,
            border: '3px solid #e7e5e4',
            borderTop: '3px solid #1c1917',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            '@keyframes spin': {
              '0%': { transform: 'rotate(0deg)' },
              '100%': { transform: 'rotate(360deg)' }
            }
          }}
        />
        <Typography color="text.secondary">
          Redirection en cours...
        </Typography>
      </Box>
    );
  }

  // Redirect based on user role
  if (userProfile.role === 'client') {
    return <Navigate to="/client-dashboard" replace />;
  } else if (userProfile.role === 'admin') {
    return <Navigate to="/admin" replace />;
  } else if (userProfile.role === 'salon' || !userProfile.role) {
    // Salon owners and users without explicit role go to professional dashboard
    return <Navigate to="/dashboard" replace />;
  } else {
    // Fallback for any other role
    return <Navigate to="/dashboard" replace />;
  }
};

export default DashboardRedirect;